import script from "./floatButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./floatButton.vue?vue&type=script&setup=true&lang=ts"

import "./floatButton.vue?vue&type=style&index=0&id=153fe994&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153fe994"]])

export default __exports__